/**
 * @param {HTMLElement} section
 */
const initializePromotionBannerCollection = (section) => {
  const shouldStartMuted = section.dataset.startMuted === 'true';
  const shouldAutoplayOnViewport = section.dataset.autoplayOnViewport === 'true';
  const shouldClickToUnmute = section.dataset.clickToUnmute === 'true';

  /** @type {NodeListOf<HTMLVideoElement>} */
  const videos = section.querySelectorAll('video.promotion-banner-collection__media-video');

  if (!videos.length) return;

  videos.forEach((video) => {
    video.muted = shouldStartMuted;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    if (shouldClickToUnmute) {
      video.addEventListener('click', () => {
        if (video.muted) video.muted = false;
      });
    }
  });

  if (!shouldAutoplayOnViewport || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = /** @type {HTMLVideoElement} */ (entry.target);

        if (entry.isIntersecting) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.35 }
  );

  videos.forEach((video) => {
    observer.observe(video);
  });
};

/** @type {NodeListOf<HTMLElement>} */
const promotionBannerSections = document.querySelectorAll('.promotion-banner-collection');

promotionBannerSections.forEach((section) => {
  initializePromotionBannerCollection(section);
});
